import { sortFolderEnum, advancedOrder } from 'enum/folder.enum'
import { ICourseModel } from 'models/course.model'

export type IFolderSortSettingsField = {
  attribute: keyof ICourseModel | typeof advancedOrder
  /**
   * @description asc by default
   */
  direction: sortFolderEnum | undefined | null
}

export interface IFolderSortSettings {
  fields?: IFolderSortSettingsField[]
}

export interface IFolderModel {
  id?: number
  name: string
  show: boolean
  order: number
  coursesCount?: number
  created_at?: string
  courses?: {
    data: { id: string; attributes: ICourseModel }[]
  }
  sortSettings?: IFolderSortSettings
}

export const folderInitialState: IFolderModel = {
  name: '',
  show: true,
  order: 0,
}

export const NewFolder = (name: string, order: number): IFolderModel => {
  const folder = folderInitialState

  folder.name = name
  folder.order = order

  return folder
}
